
    <fieldmagic-primary-button
      label="Close"
      icon="times"
      variant="error"
      (click)="onClick()"
      [disabled]="disabled"
    >
    </fieldmagic-primary-button>
  